import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import Additional from './Additional/index.js';
import Star3 from '../../Layers/star-3.png.js';
import ShadowImage from '../../Layers/shadow.png.js';
import styles from './index.module.scss.js';

const GameSkin = ({
  id,
  href,
  title,
  subtitle = "Housebets",
  size = "MD",
  type,
  customizedLayers,
  imageLayers,
  additionalInfo,
  index,
  className,
  style,
  ...props
}) => {
  const getTitle = () => type === "GAME" && /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.title, "game-card__title"),
      dangerouslySetInnerHTML: {
        __html: title || ""
      }
    }
  );
  const getSubtitle = () => type === "GAME" && /* @__PURE__ */ React.createElement("div", { className: cx(styles.subtitle, "game-card__subtitle") }, subtitle);
  return /* @__PURE__ */ React.createElement(
    Link,
    {
      className: `${cx(styles.box, "game-card", {
        [styles[type || ""]]: !!type,
        [styles[size || ""]]: !!size,
        [styles.CUSTOM_GRADIENT_LAYERS]: customizedLayers
      })} ${className}`,
      "data-game-type": type,
      to: href || "/",
      key: index,
      style: {
        ...style
      },
      ...props
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.box__inner }, /* @__PURE__ */ React.createElement("div", { className: cx(styles.media, "game-card__media") }, /* @__PURE__ */ React.createElement("div", { className: styles.media__wrapper }, /* @__PURE__ */ React.createElement("div", { className: styles.media__img }, /* @__PURE__ */ React.createElement(
      "img",
      {
        src: customizedLayers ? customizedLayers.mediaImage : imageLayers?.mediaImage,
        alt: title
      }
    )), /* @__PURE__ */ React.createElement("img", { src: Star3, className: styles.star_3, alt: "card star" }), getTitle())), subtitle && getSubtitle(), /* @__PURE__ */ React.createElement("img", { className: styles.shadow, src: ShadowImage, alt: "shadow" }), imageLayers?.backgroundImage && /* @__PURE__ */ React.createElement(
      "img",
      {
        className: styles.background,
        src: imageLayers.backgroundImage,
        alt: "background"
      }
    )),
    additionalInfo && /* @__PURE__ */ React.createElement(Additional, { ...additionalInfo, v2: type === "GAME_SIMPLE_SMALL" })
  );
};

export { GameSkin as default };
//# sourceMappingURL=index.js.map
